import React from 'react';
import PropTypes from 'prop-types';
import '../styles/ContentBodyTop.scss';

const ContentBodyTop = ({left, center, right}) => {
    return (
        <div className="content-body-top">
            <div className="left">{left}</div>
            <div className="center">{center}</div>
            <div className="right">{right}</div>
        </div>
    );
};

ContentBodyTop.propTypes = {
    left: PropTypes.node,
    center: PropTypes.node,
    right: PropTypes.node
};

export default ContentBodyTop;
